import React, { useEffect } from "react";
import ReactTable from "@dhn/components/molecules/data-table";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  TabPane,
} from "reactstrap";
import useActions from "./useActions";
import ModalAllergyDetail from "./modals/ModalAllergyDetail";
import AsyncSelect from "react-select/async";
import SelectableOption, {
  SelectableOptionGroup,
} from "@dhn/components/molecules/selectable-option";

export default function Allergies(
  {
    dataAppointment,
    dataDoctor,
    activeTab,
    data: dataAllergies,
    onChangeFather,
    loadingAllergies,
    handleUpdateDeniesHistory,
  },
  ref,
) {
  const [{ state }, actions] = useActions({
    dataAppointment,
    dataDoctor,
    activeTab,
    data: dataAllergies,
    onChangeFather,
    handleUpdateDeniesHistory,
  });

  const {
    onChange,
    toggleModal,
    loadOptionsMoleculesOrAllergies,
    handleAddMoleculeOrGroup,
    handleRemoveData,
    handleDeniesHistory,
  } = actions;

  const { filterType, isOpenModal, selectedItem, isLoadingSelect, data } =
    state;

  const nameLabel = filterType === "GRUPO" ? "Grupo Alérgico" : "Molécula";

  const deniesHistory = dataAppointment?.patient?.deniesHistory ?? true;
  const hasAllergies = data?.filter((item) => !item?.isRemoved)?.length > 0;
  const showAllergyForm = hasAllergies || !deniesHistory;

  // Auto-actualizar deniesHistory a false cuando se agregan alergias
  useEffect(() => {
    if (hasAllergies && deniesHistory) {
      handleUpdateDeniesHistory(false);
    }
  }, [hasAllergies, deniesHistory, handleUpdateDeniesHistory]);

  return (
    <TabPane tabId={7} className="p-0 m-0">
      <div className="animated fadeIn">
        <Card>
          <CardBody>
            <Row form className="mb-3">
              <Col md={12}>
                <Label className="font-weight-bold">
                  ¿Tiene alergias?
                </Label>
                <SelectableOptionGroup columns={4}>
                  <SelectableOption
                    inputType="radio"
                    inputName="deniesHistory"
                    id="deniesHistoryYes"
                    icon="fa-ban"
                    title="Niega Historial"
                    compact
                    checked={deniesHistory === true}
                    disabled={hasAllergies}
                    onChange={handleDeniesHistory}
                  />
                  <SelectableOption
                    inputType="radio"
                    inputName="deniesHistory"
                    id="deniesHistoryNo"
                    icon="fa-exclamation-triangle"
                    title="Si"
                    compact
                    checked={deniesHistory === false}
                    disabled={hasAllergies}
                    onChange={() => handleUpdateDeniesHistory(false)}
                  />
                </SelectableOptionGroup>
                {hasAllergies && (
                  <small className="text-muted mt-1 d-block">
                    El paciente tiene alergias registradas.
                  </small>
                )}
              </Col>
            </Row>

            {showAllergyForm && (
              <>
                <hr />
                <Row form className="mb-3 align-items-end">
                  <Col md={3}>
                    <Label>Filtrar por:</Label>
                    <SelectableOptionGroup columns={2}>
                      <SelectableOption
                        inputType="radio"
                        inputName="filterType"
                        icon="fa-object-group"
                        title="Grupo Alérgico"
                        compact
                        checked={filterType === "GRUPO"}
                        onChange={() => onChange("filterType", "GRUPO")}
                      />
                      <SelectableOption
                        inputType="radio"
                        inputName="filterType"
                        icon="fa-flask"
                        title="Molécula"
                        compact
                        checked={filterType === "MOLECULA"}
                        onChange={() => onChange("filterType", "MOLECULA")}
                      />
                    </SelectableOptionGroup>
                  </Col>
                  <Col md={4}>
                    <Label>{nameLabel}</Label>
                    <AsyncSelect
                      defaultOptions={false}
                      loading={isLoadingSelect || loadingAllergies}
                      loadOptions={loadOptionsMoleculesOrAllergies}
                      getOptionValue={(item) => item.id}
                      getOptionLabel={(item) => item.name}
                      placeholder={`Buscar ${nameLabel}`}
                      value={null}
                      onChange={handleAddMoleculeOrGroup}
                    />
                  </Col>
                </Row>

                <Row form>
                  <Col md={12}>
                    <ReactTable
                      data={data?.filter((item) => !item?.isRemoved) || []}
                      loading={loadingAllergies}
                      noDataText="No se encontraron grupos alérgicos"
                      className="-striped -highlight"
                      defaultPageSize={10}
                      showPagination={false}
                      columns={[
                        {
                          Header: "Tipo",
                          className: "text-center",
                          accessor: "type",
                        },
                        {
                          Header: "Grupo Alérgico",
                          accessor: "allergyGroup.name",
                        },
                        {
                          Header: "Moléculas",
                          accessor: "molecule.name",
                        },
                        {
                          Header: "Opciones",
                          width: 300,
                          Cell: ({ original }) => {
                            return (
                              <FormGroup>
                                <Button
                                  color="danger"
                                  type="button"
                                  onClick={() => handleRemoveData(original)}
                                  className="btn-color-danger card-header-action"
                                >
                                  <i className={"fa fa-trash"} />
                                  {"  Borrar"}
                                </Button>
                                <Button
                                  hidden={original.type === "MOLECULA"}
                                  className="btn-gray-600 card-header-action ml-2"
                                  onClick={() => toggleModal(true, original)}
                                >
                                  <i className="fa fa-eye"></i>{" "}
                                  {" Detalle de Grupo Alérgico"}
                                </Button>
                              </FormGroup>
                            );
                          },
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </>
            )}
          </CardBody>
        </Card>

        <ModalAllergyDetail
          isOpen={isOpenModal}
          toggle={toggleModal}
          selectedItem={selectedItem}
        />
      </div>
    </TabPane>
  );
}
